module.exports = __webpack_public_path__ + "media/images/countryrect/to-904d7a23c841ee3ac851fea9eeee4bc0.svg";